/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2021-12-02 16:55:10
 * @Description: 
 */

import { Progress } from "antd";
import React from "react";
import FTCanvasStore from "src/store/FTCanvasStore";
import FTLang from "src/utils/FTLang";
import "./FTDownloadLoading.scss"
class FTDownloadLoading extends React.Component {
  state = {
    percent: 0,
    isMobile: false
  }
  timer: any = null
  componentDidMount() {
    this.timer = setInterval(() => {
      let { percent } = this.state
      percent = percent + 3
      this.setState({
        percent: percent > 100 ? 100 : percent
      })
    }, 500)
  }

  componentWillUnmount() {
    clearInterval(this.timer)
    this.timer = null
  }
  render() {
    let { percent } = this.state
    let { isMobile } = FTCanvasStore
    return <div className={`download_loading ${isMobile ? "download_loading_mobile" : ""}`}>
      <div className="download_loading_text">
        { FTLang._("goart_downloading")}
      </div>
      <div className="download_loading_process">
        <Progress percent={percent} showInfo={false} />
      </div>
    </div>
  }
}

export default FTDownloadLoading
